'use client';

import type { LucideIcon } from 'lucide-react';
import type React from 'react';

interface ITrackingPillProps {
  icon: LucideIcon;
  label: string;
  active?: boolean;
  ariaPressed?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function TrackingPill({
  icon: Icon,
  label,
  active = false,
  ariaPressed,
  disabled = false,
  onClick,
}: ITrackingPillProps): React.JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={ariaPressed}
      disabled={disabled}
      onClick={onClick}
      className={`inline-flex h-9 items-center gap-1.5 rounded-full border px-3.5 text-sm font-medium transition outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50 ${
        active
          ? 'border-primary bg-primary/10 text-foreground'
          : 'border-border bg-card text-muted-foreground hover:bg-muted hover:text-foreground'
      }`}
    >
      <Icon className={active ? 'size-4 fill-current' : 'size-4'} aria-hidden />
      {label}
    </button>
  );
}
